module.exports = __webpack_public_path__ + "img/damage_blaupause_dark.36ea56c2.gif";